var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconBranchTopRight = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-691.667 -387.583)" },
                React.createElement("path", { d: "M706.2,389.6v12.4c0,1.2,1,2.2,2.2,2.2h4.7" }),
                React.createElement("path", { d: "M719.9,404.2c0,1.8-1.5,3.2-3.2,3.2s-3.2-1.5-3.2-3.2s1.5-3.2,3.2-3.2S719.9,402.5,719.9,404.2z\n\t\t" }),
                React.createElement("path", { d: "M709.5,389.4H703" })))));
});
export default IconBranchTopRight;
//# sourceMappingURL=IconBranchTopRight.js.map